import { FC, useEffect } from "react";
import { useLocation } from "react-router-dom";

interface PageTitle {
  title: string;
}

const PageTitle: FC<PageTitle> = ({ title }) => {
  const location = useLocation();

  useEffect((): void => {
    document.title = title;
  }, [location, title]);

  return null;
};

export default PageTitle;
